import { RootState } from '@glass/web/modules/redux/types';
import { USER_CONFIG_REDUCER_KEY } from '@glass/web/modules/userConfig/deprecatedTypes';

const selectUserConfig = (state: RootState) => state?.[USER_CONFIG_REDUCER_KEY] || null;

export default selectUserConfig;
